import { GenesysChatCloudService } from "./genesys.chat.cloud.service";
import { GenesysChatPremiseService } from "./genesys.chat.premise.service";
import { GenesysChatApiService } from "./genesys.chat.api.service";
import { GenesysWebMessagingService } from "./genesys.web.messaging.service";
import { DigitalConnectService } from "./digital.connect.service";
import { CXOneDFOChatService } from "./cxone.chat.dfo.service";
import { VerintLiveChatService } from "./verint.messaging.service";
class ConversationFactoryCtrl {
    create(config, handlers = {
        error: console.error,
        messageError: console.error,
    }, commonClient, authClient) {
        switch (config.chatMode) {
            case "genesys-api":
                this._instance = new GenesysChatApiService(Object.assign({}, config), handlers, true);
                break;
            case "genesys-premise":
                this._instance = new GenesysChatPremiseService(Object.assign({}, config), handlers);
                break;
            case "genesys-cloud":
                this._instance = new GenesysChatCloudService(Object.assign({}, config), handlers);
                break;
            case "genesys-web-messaging":
                this._instance = new GenesysWebMessagingService(Object.assign({}, config), handlers);
                break;
            case "talkdesk-digital-connect":
                this._instance = new DigitalConnectService(Object.assign({}, config), handlers, commonClient, authClient);
                break;
            case "cxone-dfo-chat":
                this._instance = new CXOneDFOChatService(Object.assign({}, config), handlers);
                break;
            case "verint-chat":
                this._instance = new VerintLiveChatService(Object.assign({}, config), handlers);
                break;
        }
    }
    get instance() {
        if (!this._instance) {
            throw new Error("conversation service not initialised");
        }
        return this._instance;
    }
}
export const ConversationFactory = new ConversationFactoryCtrl();
//# sourceMappingURL=conversation.factory.js.map